import { useEffect, useRef } from 'react'

import { useAnalyticsConsent } from './consent'

const CLARITY_PROJECT_ID = 'njk4hc4fhh'
const CLARITY_SCRIPT_URL = 'https://www.clarity.ms/tag/'

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[] }

declare global {
  interface Window {
    clarity?: ClarityFn
  }
}

export function loadClarityOnce(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.clarity) return

  const queue: ClarityFn = function clarity() {
    // eslint-disable-next-line prefer-rest-params
    ;(queue.q = queue.q || []).push(arguments)
  }
  window.clarity = queue

  const script = document.createElement('script')
  script.async = true
  script.src = `${CLARITY_SCRIPT_URL}${CLARITY_PROJECT_ID}`
  const first = document.getElementsByTagName('script')[0]
  if (first?.parentNode) {
    first.parentNode.insertBefore(script, first)
  } else {
    document.head.appendChild(script)
  }
}

function setClarityConsent(granted: boolean): void {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') return
  const value = granted ? 'granted' : 'denied'
  window.clarity('consentv2', { ad_Storage: value, analytics_Storage: value })
}

export function useClarity(): void {
  const hasConsent = useAnalyticsConsent()
  const loadedRef = useRef(false)

  useEffect(() => {
    if (hasConsent) {
      if (loadedRef.current) {
        // re-granted after a withdrawal in the same session.
        setClarityConsent(true)
        return
      }
      loadClarityOnce()
      loadedRef.current = true
      return
    }

    if (loadedRef.current) {
      setClarityConsent(false)
    }
  }, [hasConsent])
}
